<script >
import { defineProps } from '@vue/composition-api';
import { useVuelidate } from '@vuelidate/core';
import { FormActions, FormActionsNext, FormActionsPrevious } from '@/components/wizard-form/formStepActions';
import { required, numeric, maxLength, minLength } from '@/utils/validationErrors';
const __sfc_main = {};
__sfc_main.props = {
  formData: {
    type: Object
  },
  isLastStep: {
    type: Boolean,
    required: true
  },
  isFirstStep: {
    type: Boolean,
    required: true
  },
  handleNext: {
    type: Function,
    required: true
  },
  handlePrevious: {
    type: Function
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const rules = {
    documentOwner: {
      required,
      maxLength: maxLength(18),
      minLength: minLength(14)
    },
    stateRegistration: {
      required,
      numeric,
      maxLength: maxLength(14),
      minLength: minLength(9)
    }
  };
  const v$ = useVuelidate(rules, props.formData);
  async function handleSubmit() {
    const isValid = await v$.value.$validate();
    if (isValid) props.handleNext();
  }
  return {
    v$,
    handleSubmit
  };
};
__sfc_main.components = Object.assign({
  FormActions,
  FormActionsPrevious,
  FormActionsNext
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>

  <form class="wrapper-form" @submit.prevent="handleSubmit">

    <o-field
      v-mask="['###.###.###-##', '##.###.###/####-##']"
      :label="$t('vehicle.documentOwnerLabel')"
      label-for="documentOwner"
      :message="v$.documentOwner.$errors.length ? v$.documentOwner.$errors[0].$message : null"
    >
      <o-input
        id="documentOwner"
        v-model="formData.documentOwner"
        :placeholder="$t('vehicle.documentOwnerPlaceholder')"
      />
    </o-field>

    <o-field
      :label="$t('vehicle.stateRegistrationLabel')"
      label-for="stateRegistration"
      :message="v$.stateRegistration.$errors.length ? v$.stateRegistration.$errors[0].$message : null"
    >
      <o-input
        id="stateRegistration"
        v-model="formData.stateRegistration"
        :placeholder="$t('vehicle.stateRegistrationPlaceholder')"
      />
    </o-field>

    <o-field
      :label="$t('vehicle.trackerCompanyLabel')"
      label-for="trackerCompany"
    >
      <o-input
        id="trackerCompany"
        v-model="formData.trackerCompany"
        :placeholder="$t('vehicle.trackerCompanyPlaceholder')"
      />
    </o-field>

    <o-field
      :label="$t('vehicle.trackerCompanyCodeLabel')"
      label-for="trackerCompanyCode"
    >
      <o-input
        id="trackerCompanyCode"
        v-model="formData.trackerCompanyCode"
        :placeholder="$t('vehicle.trackerCompanyCodePlaceholder')"
      />
    </o-field>

    <FormActions>
      <FormActionsPrevious :is-first-step="isFirstStep" @handlePrevious="handlePrevious" />
      <FormActionsNext :is-last-step="isLastStep" />
    </FormActions>
  </form>

</template>

<style scoped>
  .wrapper-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem/* 16px */;
    padding-top: 0.5rem/* 8px */;
    padding-bottom: 0.5rem/* 8px */;
  }

  .wrapper-buttons {
    display: flex;
    justify-content: space-between;
    grid-column: span 2 / span 2;
    padding-top: 0.5rem/* 8px */;
  }
</style>
